<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8">
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <ErrorMessage v-if="errors.load" :error="errors.load" />

    <Loader v-if="loading" />
    <div v-else class="py-8 max-w-lg mx-auto">
      <div class="space-y-8 divide-y divide-gray-200">
        <div>
          <div class="text-center">
            <p class="text-sm font-medium text-gray-700">Загрузить фото</p>

            <img :src="userphoto" alt="" class="h-40 mt-2 rounded-sm mx-auto" />

            <form @submit.prevent="submit" class="mt-2">
              <label
                for="file-upload"
                class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
              >
                <span>Выберите файл для загрузки</span>
                <input
                  @change="onAttachmentChange"
                  id="file-upload"
                  name="file-upload"
                  type="file"
                  class="sr-only"
                />
              </label>

              <button
                type="submit"
                class="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Загрузить
              </button>

              <ErrorMessage
                v-if="errors.uploadfile"
                :error="errors.uploadfile"
              />
            </form>
          </div>
          <form class="space-y-4">
            <input type="hidden" name="id" v-model="data.id" />

            <div>
              <label
                for="fullname"
                class="block text-sm font-medium text-gray-700"
              >
                Полное имя
                <span title="Эта информация будет видна всем пользователям!"
                  >(публичное поле)</span
                >
              </label>
              <div class="mt-1">
                <input
                  v-model="data.fullname"
                  type="text"
                  name="fullname"
                  id="fullname"
                  autocomplete="fullname"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>



            <!-- Должность - только для мед.работников: -->
            <div
              v-if="!data.is_simple"
            >
              <label
                for="doljnost"
                class="block text-sm font-medium text-gray-700"
              >
                Должность
                <span title="Эта информация будет видна всем пользователям!"
                  >(публичное поле)</span
                >
              </label>
              <div class="mt-1">
                <input
                  v-model="data.doljnost"
                  type="text"
                  name="doljnost"
                  id="doljnost"
                  autocomplete="doljnost"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>

            <div>
              <label
                for="contacts"
                class="block text-sm font-medium text-gray-700"
              >
                Контактная информация
                <span title="Эта информация будет видна всем пользователям!"
                  >(публичное поле)</span
                >
              </label>
              <div class="mt-1">
                <input
                  v-model="data.contacts"
                  type="text"
                  name="contacts"
                  id="contacts"
                  autocomplete="contacts"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>

            <div>
              <div class="flex justify-end">
                <button
                  @click.prevent="editRecord()"
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Сохранить изменения
                </button>
              </div>
              <ErrorMessage
                v-if="errors.edit"
                :error="errors.edit"
                class="mt-2"
              />

            </div>
          </form>



          <hr class="mt-4 mb-4">
          <h3 class="text-2xl text-center tracking-tight font-extrabold text-gray-900 sm:text-2xl">Смена пароля</h3>
          <form class="space-y-4 mt-2">
            <div>
              <label for="oldpass" class="block text-sm font-medium text-gray-700">
                Старый пароль
              </label>
              <div class="mt-1">
                <input
                  v-model="oldpass"
                  type="password"
                  name="oldpass"
                  id="oldpass"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>
            <div>
              <label for="newpass1" class="block text-sm font-medium text-gray-700">
                Новый пароль
              </label>
              <div class="mt-1">
                <input
                  v-model="newpass1"
                  type="password"
                  name="newpass1"
                  id="newpass1"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>
            <div>
              <label for="newpass2" class="block text-sm font-medium text-gray-700">
                Новый пароль ещё раз
              </label>
              <div class="mt-1">
                <input
                  v-model="newpass2"
                  type="password"
                  name="newpass2"
                  id="newpass2"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>
            <div>
              <div class="flex justify-end">
                <button
                  @click.prevent="saveNewPass()"
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Сохранить новый пароль
                </button>
              </div>
              <ErrorMessage
                v-if="errors.newpass"
                :error="errors.newpass"
                class="mt-2"
              />
              <SuccessMessage
                v-if="success.newpass"
                :msg="success.newpass"
                class="mt-2"
              />

            </div>



          </form>




        </div>






      </div>


    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import ErrorMessage from "../components/ErrorMessage.vue";
import SuccessMessage from "../components/SuccessMessage.vue";

export default {
  name: "dashboard",
  data() {
    return {
      loading: true,
      data: [],
      oldpass: '',
      newpass1: '',
      newpass2: '',
      errors: { load: "", edit: "", uploadfile: "", newpass: '' },
      success: { newpass: '' },
      attachment: null,
      userphoto: null,
      title: "Редактирование профиля",
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.success = {};
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("user/profileEdit");
        this.data = response.data.user;
        this.userphoto = this.data.userphoto;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },



    //
    // Save new password.
    //
    async saveNewPass() {
      this.errors.newpass = '';
      if (this.newpass1 != this.newpass2) {
        this.errors.newpass = 'Пароли не совпадают!'
        return
      }
      if (this.oldpass == this.newpass1) {
        this.errors.newpass = 'Новый пароль не может быть равен старому!'
        return
      }

      try {
        let tmpobj = { oldpass: this.oldpass, newpass1: this.newpass1, newpass2: this.newpass2}
        let response = await axios.post(
          "user/savenewpass",
          Object.assign(tmpobj)
        );
        if (response.status == 200) {
          this.oldpass = ''
          this.newpass1 = ''
          this.newpass2 = ''
          this.success.newpass = 'Пароль изменён!'
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.newpass = e.response.data.error;
        } else {
          this.errors.newpass = "Неизвестная ошибка при изменении пароля.";
        }
      }
    },


    //
    // Edit record.
    //
    async editRecord() {
      this.errors.validationEdit = {};
      this.errors.edit = "";
      try {
        let response = await axios.post(
          "user/profileUpdate/" + this.data.id,
          Object.assign(this.data, { _method: "PUT" })
        );
        if (response.status == 200) {
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationEdit = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.edit = e.response.data.error;
        } else {
          this.errors.edit = "Неизвестная ошибка при редактировании профиля.";
        }
      }
    },

    onAttachmentChange(e) {
      this.attachment = e.target.files[0];
    },
    submit() {
      this.errors.uploadfile = "";
      const config = { "content-type": "multipart/form-data" };
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("attachment", this.attachment);

      axios
        .post("user/profileUploadAvatar", formData, config)
        .then((response) => {
          this.userphoto = response.data.userphoto;
        })
        .catch((error) => {
          if (error.response.status == 520) {
            this.errors.uploadfile = error.response.data.error;
          }
          if (error.response.status == 422) {
            this.errors.uploadfile = error.response.data.errors.attachment[0];
          } else {
            this.errors.uploadfile = "Неизвестная ошибка при загрузке файла.";
          }
        });
    },
  },
  components: {
    Loader,
    PageTitle,
    ErrorMessage,
    SuccessMessage,
  },
};
</script>